import Card from 'components/card';
import Nodatafound from 'pages/Common/Nodatafound';
import { useState } from 'react';
import { BallTriangle } from 'react-loader-spinner';

const StudentData = ({
  attendance,
  confirmPlacementReady,
  setAttendance,
  loading = false,
}) => {
  const [searchQuery, setSearchQuery] = useState('');

  /* ================= PRIORITY CHANGE ================= */
  const handlePriorityChange = (studentId, value) => {
    setAttendance((prev) =>
      prev.map((student) =>
        (student.id || student._id) === studentId
          ? { ...student, placementPriority: value }
          : student
      )
    );
  };

  /* ================= FILTER ================= */
  const filteredStudents = attendance.filter((student) =>
    student.name.toLowerCase().includes(searchQuery.toLowerCase())
  );

  return (
    <Card extra="w-full sm:overflow-auto p-4">
      {/* NOTE */}
      <div className="mt-4 flex justify-center text-sm text-gray-600 dark:text-white">
        <b>Note:</b>&nbsp;Click "Mark Ready" to mark a student as ready for
        placement.
      </div>

      {/* SEARCH */}
      <div className="mt-6 flex justify-start">
        <div className="relative w-full max-w-md">
          <input
            type="text"
            placeholder="Search by student name..."
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            className="w-full rounded-md border px-4 py-2 text-sm dark:bg-navy-700 dark:text-white"
          />
          {searchQuery && (
            <button
              onClick={() => setSearchQuery('')}
              className="absolute right-3 top-2 text-gray-400"
            >
              ✕
            </button>
          )}
        </div>
      </div>

      {/* TABLE / STATES */}
      {loading ? (
        <div className="flex h-64 items-center justify-center">
          <BallTriangle color="#5431ed" />
        </div>
      ) : attendance.length === 0 ? (
        <div className="mt-6 flex justify-center">
          <Nodatafound title="No student data found." />
        </div>
      ) : (
        <div className="mt-8 overflow-x-auto">
          <table className="w-full">
            <thead>
              <tr className="border-b">
                {['SR.NO', 'NAME', 'PRIORITY', 'STATUS', 'ACTION'].map((h) => (
                  <th
                    key={h}
                    className="px-6 py-4 text-center text-xs font-bold"
                  >
                    {h}
                  </th>
                ))}
              </tr>
            </thead>

            <tbody>
              {filteredStudents.length > 0 ? (
                filteredStudents.map((student, index) => {
                  const studentId = student.id || student._id;

                  return (
                    <tr
                      key={studentId}
                      className={`border-b ${
                        student.ready ? 'bg-green-50 dark:bg-green-900/10' : ''
                      }`}
                    >
                      <td className="py-4 text-center">{index + 1}</td>
                      <td className="py-4 text-center">{student.name}</td>

                      <td className="py-4 text-center">
                        <select
                          value={student.placementPriority}
                          onChange={(e) =>
                            handlePriorityChange(studentId, e.target.value)
                          }
                          disabled={student.ready}
                          className="dark:bg-navy-800"
                        >
                          <option value="High">High</option>
                          <option value="Medium">Medium</option>
                          <option value="Low">Low</option>
                        </select>
                      </td>

                      <td className="py-4 text-center">
                        {student.ready ? (
                          <span className="rounded bg-green-100 px-2 py-1 text-xs text-green-700">
                            Ready
                          </span>
                        ) : (
                          <span className="rounded bg-yellow-100 px-2 py-1 text-xs text-yellow-700">
                            Not Ready
                          </span>
                        )}
                      </td>

                      <td className="py-4 text-center">
                        <button
                          onClick={() => confirmPlacementReady(student)}
                          disabled={student.ready}
                          className={`rounded px-3 py-1 text-xs ${
                            student.ready
                              ? 'cursor-not-allowed bg-gray-300'
                              : 'bg-brand-500 text-white hover:bg-brand-600'
                          }`}
                        >
                          {student.ready ? 'Already Ready' : 'Mark Ready'}
                        </button>
                      </td>
                    </tr>
                  );
                })
              ) : (
                <tr>
                  <td colSpan={5} className="py-8 text-center text-gray-500">
                    No students found for "{searchQuery}"
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      )}
    </Card>
  );
};

export default StudentData;
